import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { trackWhatsAppClick } from '../utilities/trackingUtils';
import './WhatsAppIcon.css';

const WhatsAppIcon = () => {
  const handleWhatsAppClick = () => {
    // Track the WhatsApp click
    trackWhatsAppClick('WhatsApp Icon Bottom');
    
    // Directly redirect to WhatsApp
    window.open('https://wa.me/917816088532', '_blank');
  };

  return (
    <div className="whatsapp-container">
      {/* WhatsApp Icon */}
      <button className="whatsapp-icon" onClick={handleWhatsAppClick} title="Chat on WhatsApp" aria-label="Open WhatsApp">
        <FaWhatsapp />
      </button>
    </div>
  );
};

export default WhatsAppIcon; 